export { default } from './HideSmallGroup'
